// @ts-nocheck
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import {
  ArrowLeft,
  ArrowRight,
  BrainCircuit,
  FileScan,
  Gavel,
  Layers3,
  ShieldCheck,
  Target,
} from "lucide-react";
import SeoHead from "./SeoHead";

const SITE_URL = "https://orionintelligence.net";

const colors = {
  bgTop: "#070b18",
  bgBottom: "#101827",
  primary: "#19E6FF",
  textMuted: "#a7b4c7",
  cardBg: "rgba(15, 23, 42, 0.62)",
  cardBorder: "rgba(255,255,255,0.12)",
};

const iconMap = {
  legal: Gavel,
  invoice: FileScan,
  ai: BrainCircuit,
};

export const caseStudies = {
  "casemaster-legal-tech": {
    icon: "legal",
    eyebrow: "Legal Tech Case Study",
    title: "CaseMaster: οργάνωση υποθέσεων για νομικά γραφεία",
    seoTitle: "CaseMaster Case Study | Legal Tech Πλατφόρμα από την Orion Intelligence",
    description:
      "Case study για το CaseMaster, μια legal tech πλατφόρμα οργάνωσης υποθέσεων, πελατών, προθεσμιών και ασφαλούς ροής εργασίας για νομικά γραφεία.",
    challenge:
      "Τα νομικά γραφεία δουλεύουν με πολλές υποθέσεις, προθεσμίες, πελάτες, έγγραφα και συνεχείς υπενθυμίσεις. Όταν όλα είναι μοιρασμένα σε email, αρχεία και σημειώσεις, αυξάνεται ο κίνδυνος λάθους και χάνεται χρόνος.",
    solution:
      "Το CaseMaster σχεδιάστηκε ως legal tech πλατφόρμα που συγκεντρώνει υποθέσεις, πελάτες, deadlines και βασικές ροές εργασίας σε ένα οργανωμένο περιβάλλον, με έμφαση στην ασφάλεια και την απλότητα χρήσης.",
    outcomes: [
      "Κεντρική εικόνα για υποθέσεις, πελάτες και προθεσμίες",
      "Πιο καθαρή καθημερινή ροή εργασίας για δικηγόρους και συνεργάτες",
      "Βάση για AI-assisted legal workflows και μελλοντικές αυτοματοποιήσεις",
      "Πιο επαγγελματική εμπειρία για εσωτερική οργάνωση νομικού γραφείου",
    ],
    stack: ["React", "Firebase", "Stripe", "Cloud APIs", "Security headers", "GDPR-first flows"],
    serviceLinks: [
      { label: "Legal tech", href: "/legal-tech" },
      { label: "Custom software", href: "/custom-software" },
      { label: "Cloud apps", href: "/cloud-apps" },
    ],
  },
  "invoice-intelligence": {
    icon: "invoice",
    eyebrow: "Invoice Automation Case Study",
    title: "Invoice Intelligence: AI ανάγνωση τιμολογίων και παραστατικών",
    seoTitle: "Invoice Intelligence Case Study | Invoice Automation από την Orion Intelligence",
    description:
      "Case study για AI invoice automation: αναγνώριση παραστατικών, extraction δεδομένων και ERP-ready JSON output για επιχειρήσεις και ERP providers.",
    challenge:
      "Η χειροκίνητη καταχώρηση τιμολογίων είναι αργή, επαναλαμβανόμενη και ευάλωτη σε λάθη. Για λογιστήρια, προμήθειες και ERP ομάδες, κάθε λεπτό που χάνεται σε αντιγραφή δεδομένων κοστίζει.",
    solution:
      "Το Invoice Intelligence χρησιμοποιεί AI/OCR για να διαβάζει PDF ή εικόνες παραστατικών, να εξάγει βασικά πεδία και να επιστρέφει δομημένο αποτέλεσμα έτοιμο για ERP, dashboard ή review flow.",
    outcomes: [
      "Αυτόματη εξαγωγή προμηθευτή, ημερομηνίας, ποσών και γραμμών τιμολογίου",
      "API-first λογική για σύνδεση με ERP ή εσωτερικά συστήματα",
      "Μείωση χειροκίνητης καταχώρησης και πιο γρήγορος έλεγχος παραστατικών",
      "Δομημένο JSON output για developers και επιχειρησιακές ομάδες",
    ],
    stack: ["AI/OCR", "Node.js", "Vercel Functions", "Structured JSON", "PDF/Image input", "API security"],
    serviceLinks: [
      { label: "Invoice automation", href: "/invoice-automation" },
      { label: "AI automations", href: "/ai-automations" },
      { label: "Cloud apps", href: "/cloud-apps" },
    ],
  },
  "ai-legal-workflow": {
    icon: "ai",
    eyebrow: "AI Automation Case Study",
    title: "AI legal workflow: αυτοματισμοί για νομικές και επαγγελματικές ομάδες",
    seoTitle: "AI Legal Workflow Case Study | AI Αυτοματισμοί από την Orion Intelligence",
    description:
      "Case study για AI workflow automation σε νομικές και επαγγελματικές ομάδες: ταξινόμηση αιτημάτων, επεξεργασία εγγράφων και ασφαλείς εσωτερικές ροές.",
    challenge:
      "Πολλές ομάδες λαμβάνουν καθημερινά email, έγγραφα, αιτήματα και πληροφορίες που πρέπει να ταξινομηθούν πριν γίνει η πραγματική δουλειά. Αυτή η προετοιμασία συχνά τρώει περισσότερο χρόνο από όσο φαίνεται.",
    solution:
      "Η Orion σχεδιάζει AI workflows που διαβάζουν περιεχόμενο, ταξινομούν αιτήματα, προτείνουν επόμενα βήματα και ενημερώνουν τα σωστά συστήματα, πάντα με έλεγχο πρόσβασης και ανθρώπινη επιβεβαίωση όπου χρειάζεται.",
    outcomes: [
      "Λιγότερος χρόνος σε ταξινόμηση και χειροκίνητη προετοιμασία",
      "Πιο καθαρή εικόνα για το τι πρέπει να γίνει και από ποιον",
      "Σύνδεση AI με υπάρχοντα εργαλεία, dashboards και databases",
      "Ασφαλής αρχιτεκτονική για επαγγελματικά δεδομένα",
    ],
    stack: ["AI agents", "Workflow automation", "Document processing", "CRM updates", "Role-based access", "Audit-friendly logs"],
    serviceLinks: [
      { label: "AI automations", href: "/ai-automations" },
      { label: "Legal tech", href: "/legal-tech" },
      { label: "Custom software", href: "/custom-software" },
    ],
  },
};

function buildJsonLd(page, slug) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": page.title,
    "description": page.description,
    "author": {
      "@type": "Organization",
      "name": "Orion Intelligence",
      "url": SITE_URL,
    },
    "publisher": {
      "@type": "Organization",
      "name": "Orion Intelligence",
      "logo": {
        "@type": "ImageObject",
        "url": `${SITE_URL}/assets/orion-logo-800.png`,
      },
    },
    "mainEntityOfPage": `${SITE_URL}/case-studies/${slug}`,
    "datePublished": "2026-07-08",
    "dateModified": "2026-07-08",
  };
}

export default function CaseStudyPage({ slug }) {
  const page = caseStudies[slug] || caseStudies["casemaster-legal-tech"];
  const Icon = iconMap[page.icon] || Layers3;
  const canonical = `${SITE_URL}/case-studies/${slug}`;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [slug]);

  return (
    <div
      className="min-h-screen text-white"
      style={{
        background: `radial-gradient(1000px 520px at 0% 0%, rgba(25,230,255,0.14), transparent 62%),
                     radial-gradient(900px 520px at 100% 0%, rgba(140,251,222,0.12), transparent 58%),
                     linear-gradient(${colors.bgTop}, ${colors.bgBottom})`,
      }}
    >
      <SeoHead
        title={page.seoTitle}
        description={page.description}
        canonical={canonical}
        type="article"
        jsonLd={buildJsonLd(page, slug)}
      />

      <main className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-10 md:py-16">
        <Link to="/" className="inline-flex items-center gap-2 text-sm font-semibold text-cyan-300 hover:text-cyan-100">
          <ArrowLeft size={16} />
          Orion Intelligence
        </Link>

        <section className="grid lg:grid-cols-[1.05fr,0.95fr] gap-10 items-center pt-12">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full border border-cyan-400/30 bg-cyan-400/10 px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-cyan-200">
              <Icon size={14} />
              {page.eyebrow}
            </div>
            <h1 className="mt-5 text-3xl md:text-5xl font-black leading-tight">
              {page.title}
            </h1>
            <p className="mt-5 text-base md:text-lg leading-relaxed" style={{ color: colors.textMuted }}>
              {page.description}
            </p>
            <div className="mt-7 flex flex-wrap gap-3">
              <a
                href="/#contact"
                className="inline-flex items-center gap-2 rounded-2xl px-6 py-3.5 font-bold shadow-lg shadow-cyan-500/20"
                style={{ background: colors.primary, color: "#001018" }}
              >
                Συζητήστε παρόμοιο project
                <ArrowRight size={18} />
              </a>
              {page.serviceLinks.map((link) => (
                <Link key={link.href} to={link.href} className="inline-flex items-center rounded-2xl border border-white/10 px-4 py-3 text-sm font-bold hover:bg-white/5">
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          <div className="rounded-2xl border p-6 md:p-8" style={{ background: colors.cardBg, borderColor: colors.cardBorder }}>
            <div className="flex items-center gap-3">
              <span className="rounded-xl bg-cyan-400/10 p-3 text-cyan-300">
                <Target size={24} />
              </span>
              <div>
                <p className="text-xs uppercase tracking-wider text-slate-400">Case study</p>
                <h2 className="text-xl font-extrabold">Τι δείχνει αυτό το έργο</h2>
              </div>
            </div>
            <div className="mt-6 grid gap-3">
              {page.outcomes.map((item) => (
                <div key={item} className="flex gap-3 rounded-xl border border-white/10 bg-white/[0.03] p-4">
                  <ShieldCheck size={18} className="mt-0.5 shrink-0 text-emerald-300" />
                  <span className="text-sm leading-relaxed text-slate-200">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="grid md:grid-cols-2 gap-6 py-14">
          <div className="rounded-2xl border p-6 md:p-8" style={{ background: "rgba(255,255,255,0.04)", borderColor: colors.cardBorder }}>
            <h2 className="text-xl font-extrabold">Το πρόβλημα</h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed" style={{ color: colors.textMuted }}>
              {page.challenge}
            </p>
          </div>

          <div className="rounded-2xl border p-6 md:p-8" style={{ background: "rgba(255,255,255,0.04)", borderColor: colors.cardBorder }}>
            <h2 className="text-xl font-extrabold">Η λύση</h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed" style={{ color: colors.textMuted }}>
              {page.solution}
            </p>
          </div>
        </section>

        <section className="rounded-2xl border p-6 md:p-8" style={{ background: colors.cardBg, borderColor: colors.cardBorder }}>
          <h2 className="text-xl font-extrabold">Τεχνολογίες και δυνατότητες</h2>
          <div className="mt-5 flex flex-wrap gap-2">
            {page.stack.map((item) => (
              <span key={item} className="rounded-full bg-cyan-400/10 px-3 py-1.5 text-xs font-semibold text-cyan-200">
                {item}
              </span>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}
